module.exports = __webpack_public_path__ + "static/media/revestimientos.0440a4aa.jpg";